<template>
  <ul class="toggler" :class="{'checked2': is2, 'checked3': is3}">
    <li @click="setLevel(1)"
        :class="{'active': is1,'checked': is2 || is3}">
      <button type="button">
        {{$t('things.per1')}}
      </button>
    </li>
    <li @click="setLevel(2)"
        :class="{'active': is2, 'checked': is3}">
      <button type="button">
        {{$t('things.per2')}}
      </button>
    </li>
    <li @click="setLevel(3)"
        :class="{'active': is3}">
      <button type="button">
        {{$t('things.per3')}}
      </button>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'permissionToggler',
    props: {
      defaultVal: {
        type: Number || String,
        required: false
      }
    },
    data() {
      return {
        level: 1
      }
    },
    computed: {
      is1() {
        return this.level === 1
      },
      is2() {
        return this.level === 2
      },
      is3() {
        return this.level === 3
      }
    },
    methods: {
      setLevel(level) {
        this.level = level;
        this.$emit('level', level)
      }
    },
    mounted() {
      if (this.defaultVal) {
        this.level = this.defaultVal
      }
    }
  }
</script>

<style lang="scss" scoped>
ul.toggler {
  display: flex;
  align-items: center;
  padding: 3px;
  border-radius: 10px;
  height: 40px;
  background: #E6F4F1;
}

  li {
    width: 33%;
    height: 100%;
    position: relative;
    z-index: 1;

    button {
      width: 100%;
      height: 100%;
      font-family: $mr;
      font-size: 12px;
      color: $darkBlue;
      border-radius: 8px;
    }
  }

  .active button{
    background: white;

  }

  .checked button {
    color: white;
    background: none;
  }

  .checked2,.checked3 {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      background: $lightBlue;
      border-radius: 9px;
      width: calc(100% - 4px);
      left: 2px;
      height: calc(100% - 4px);
      top: 2px;
      z-index: 0;
    }
  }

  .checked2 {
    &::before {
      width: 66%;
    }
  }

  .checked3 {
    &::before {
      width:  calc(100% - 6px);
    }
  }
  .content ul li:before {
    display: none;
  }

  .content ul li {
    position: relative;
    margin-bottom: 0;
    padding: 3px;
  }

</style>
